<template>
  <div class="min-h-screen text-slate-100">
    <div class="mx-auto flex w-full">
      <!-- Left rail -->
      <aside class="w-2/5 shrink-0 bg-left px-6 py-10 pl-24 min-h-screen">
        <div>
          <img src="@/assets/images/decast-logo.svg" alt="decast logo" class="h-16 w-auto mb-12" />
        </div>
        <div class="flex items-center justify-start mb-8 gap-6">
          <h1 class="text-4xl font-extrabold tracking-tight text-white">
            Profile <span class="text-primary">Settings</span>
          </h1>
          <img src="@/assets/images/card.png" alt="">
        </div>

        <div class="mt-16 space-y-2 flex flex-col w-2/3">
          <p class="text-lg font-semibold tracking-wider text-slate-400">User Settings</p>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'account' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'account'">
            <img src="@/assets/images/setting.svg" class="w-6 h-6" alt="" />
            <span>Account Settings</span>
          </button>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'security' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'security'">
            <img src="@/assets/images/lock.png" class="w-6 h-6" alt="" />
            <span>Security Settings</span>
          </button>
        </div>

        <div class="mt-6 space-y-2 flex flex-col w-2/3">
          <p class="text-lg font-semibold tracking-wider text-slate-400">Linked Identities</p>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'wallet' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'wallet'">
            <img src="@/assets/images/link-wall.png" class="w-6 h-6" alt="" />
            <span>Linked Wallet</span>
          </button>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'socials' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'socials'">
            <img src="@/assets/images/linked.png" class="w-6 h-6" alt="" />
            <span>Linked Socials</span>
          </button>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'vcs' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'vcs'">
            <img src="@/assets/images/finger.png" class="w-6 h-6" alt="" />
            <span>Verifiable Credentials (VCs)</span>
          </button>
        </div>

        <div class="mt-6 space-y-2 flex flex-col w-2/3">
          <p class="text-lg font-semibold tracking-wider text-slate-400">Billing</p>

          <button
            :class="['flex items-center gap-2 px-4 py-4 rounded-md text-left font-semibold', activeSection === 'subscription' ? 'bg-primary text-black' : 'text-slate-400']"
            @click="activeSection = 'subscription'">
            <img src="@/assets/images/setting.svg" class="w-6 h-6" alt="" />
            <span>Subscription</span>
          </button>
        </div>
      </aside>

      <!-- Right content -->
      <section class="w-3/5 flex-1 bg-right px-8 py-10 flex flex-col gap-6">
        <div v-if="activeSection === 'account'" class="flex flex-col gap-6">
          <!-- Account Information -->
          <div class="flex flex-col gap-4  p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <p class="text-lg font-semibold">Account Information</p>
            </div>
            <div v-if="ui.accountInfo" class="flex flex-col mt-8 gap-4">
              <div class="flex justify-left">
                <img src="@/assets/images/avatar.png" alt="avatar" class="h-56 w-56 rounded-md" />
              </div>
              <button class="text-white w-fit focus:outline-none border-none"
                @click="setActiveModal('updateProfileModal')">Edit profile</button>
              <div class="flex flex-col gap-2">
                <label for="username" class="text-lg text-white mt-6">Username</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" placeholder="Username" v-model="form.username"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.username)" />
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <label for="email" class="text-lg text-white mt-6">Email</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" placeholder="your@example.com" v-model="form.email"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.email)" />
                </div>
              </div>
            </div>
          </div>

          <!-- User Information -->
          <div class="flex flex-col gap-4  p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <p class="text-lg font-semibold">User Information</p>
            </div>
            <div v-if="ui.userInfo" class="flex flex-col gap-4">
              <div class="flex flex-col gap-2">
                <label for="firstname" class="text-lg text-white mt-6">First Name</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" placeholder="John" v-model="form.firstName"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.firstName)" />
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <label for="lastname" class="text-lg text-white mt-6">Last Name</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" placeholder="Doe" v-model="form.lastName"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.lastName)" />
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <label for="bio" class="text-lg text-white mt-6">Bio</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <textarea placeholder="Your Bio" v-model="form.bio"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none resize-none h-24"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- DID Information -->
          <div class="flex flex-col gap-4  p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <p class="text-lg font-semibold">DID Information</p>
            </div>
            <div v-if="ui.didInfo" class="flex flex-col gap-4">
              <div class="flex flex-col gap-2">
                <label for="did" class="text-lg text-white mt-6">DID</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" :value="form.did" placeholder="Your DID"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" readonly />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.did)" />
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <label for="publickey" class="text-lg text-white mt-6">Public Key</label>
                <div class="input_cont_ relative flex items-center rounded-lg px-4 py-4 bg-transparent">
                  <input type="text" :value="form.publicKey" placeholder="Public Key"
                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" readonly />
                  <img src="@/assets/images/copy1.svg" alt="copy" class="h-5 w-5 cursor-pointer"
                    @click="copy(form.publicKey)" />
                </div>
              </div>
            </div>

            <div class="flex items-center justify-start mt-6 gap-4">
              <!-- <button
                class="px-8 py-4 text-lg font-semibold bg-transparent text-white rounded-lg hover:primary hover:text-black">
                Preview
              </button> -->
              <button class="px-8 py-4 text-lg font-semibold bg-primary text-black rounded-lg hover:bg-lime-500">
                Save Changes
              </button>
            </div>
          </div>
        </div>

        <!-- Other sections remain unchanged -->
        <div v-else-if="activeSection === 'security'" class="flex flex-col gap-6">
          <ConfigureTwoFactorAuth />
        </div>

        <!-- Wallet, Socials, VCs sections -->
        <div v-else-if="activeSection === 'wallet'" class="flex flex-col gap-6">
          <wallet />
        </div>

        <div v-else-if="activeSection === 'socials'" class="flex flex-col gap-6">
          <socials />
        </div>

        <div v-else-if="activeSection === 'vcs'" class="flex flex-col gap-6">
          <div class="flex flex-col gap-4  p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold">Verifiable Credentials</h3>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" v-model="ui.vcs" class="sr-only peer">
                <div class="w-11 h-6 bg-gray-700 rounded-full peer-checked:bg-primary"></div>
                <div
                  class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5">
                </div>
              </label>
            </div>
            <transition name="collapse" mode="out-in">
              <div v-show="ui.vcs" class="flex flex-col gap-4">
                <p class="text-lg text-white mt-6">Issue or import credentials tied to your DID.</p>
                <div class="flex items-center gap-3">
                  <button class="bg-primary text-black px-4 py-2 rounded-lg hover:bg-lime-500">Issue VC</button>
                  <button class="bg-slate-700 text-white px-4 py-2 rounded-lg hover:bg-slate-600">Import VC</button>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div v-else-if="activeSection === 'subscription'" class="flex flex-col gap-6">
          <!-- Current Subscription -->
          <div class="flex flex-col gap-4 p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <p class="text-lg font-semibold tracking-wider text-slate-400">Current Subscription</p>
            </div>
            <div v-if="isLoadingSubscription" class="flex justify-center items-center py-8">
              <p class="text-slate-400">Loading subscription...</p>
            </div>
            <div v-else-if="subscription" class="flex flex-col gap-6">
              <!-- Current Plan Card -->
              <div class="bg-slate-800 rounded-xl p-6 border-2 border-primary">
                <div class="flex justify-between items-start">
                  <div>
                    <h4 class="text-primary text-2xl font-bold">{{ subscription.planName }}</h4>
                    <p class="text-slate-200 mt-1">Active since {{ subscription.startDate }}</p>
                  </div>
                  <div class="bg-primary text-black px-4 py-2 rounded-md font-semibold">
                    {{ subscription.status }}
                  </div>
                </div>

                <div class="mt-8 flex flex-col gap-4">
                  <div v-for="(feature, i) in subscription.features" :key="i" class="flex items-center gap-3">
                    <img src="@/assets/images/landing-page/check.svg" alt="check" class="h-5 w-5"
                      style="filter: invert(88%) sepia(31%) saturate(1096%) hue-rotate(13deg) brightness(107%) contrast(96%);" />
                    <span class="text-slate-100">{{ feature }}</span>
                  </div>
                </div>

                <div class="mt-8 flex justify-between items-center border-t border-slate-700 pt-6">
                  <div>
                    <p class="text-slate-300">Next billing date</p>
                    <p class="text-white font-semibold">{{ subscription.nextBillingDate }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-slate-300">Price</p>
                    <p class="text-primary text-2xl font-bold">${{ subscription.price }}<span
                        class="text-slate-300 text-sm ml-1">/{{ subscription.billingCycle }}</span></p>
                  </div>
                </div>
              </div>

              <!-- Stripe Customer Portal -->
              <div class="mt-6">
                <div class="flex items-center justify-between">
                  <p class="text-lg font-semibold tracking-wider text-slate-400">Manage Your Subscription</p>
                </div>
                <div class="bg-slate-800 rounded-xl p-6 border border-slate-700 mt-4">
                  <p class="text-slate-200 mb-6">Access your billing information, update payment methods, and view
                    invoices through our secure customer portal.</p>

                  <div class="flex flex-wrap gap-4">
                    <button @click="openCustomerPortal"
                      class="px-6 py-3 bg-primary text-black rounded-lg hover:bg-lime-500 font-semibold flex items-center gap-2">
                      <img src="@/assets/images/setting.svg" class="w-5 h-5" alt="" />
                      <span>Manage Billing</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <div class="flex flex-col items-center justify-center py-8 gap-4">
                <p class="text-xl text-slate-300 font-semibold">No Active Subscription</p>
                <p class="text-slate-400 text-center">You don't have an active subscription. Choose a plan below to get
                  started.</p>
              </div>
            </div>
          </div>

          <!-- Available Plans -->
          <div class="flex flex-col gap-4 p-6 rounded-xl">
            <div class="flex items-center justify-between">
              <p class="text-lg font-semibold tracking-wider text-slate-400">Available Plans</p>
            </div>
            <div v-if="isLoadingPlans" class="flex justify-center items-center py-8">
              <p class="text-slate-400">Loading plans...</p>
            </div>
            <div v-else-if="availablePlans.length === 0" class="flex justify-center items-center py-8">
              <p class="text-slate-400">No plans available</p>
            </div>
            <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
              <div v-for="(plan, index) in availablePlans" :key="index"
                :class="['bg-slate-800 rounded-xl p-6 border-2', subscription && subscription.planId === plan.planId ? 'border-primary' : 'border-slate-700']">
                <h4 class="text-xl font-bold"
                  :class="subscription && subscription.planId === plan.planId ? 'text-primary' : 'text-white'">{{
                  plan.name }}</h4>
                <p class="text-slate-200 mt-1">{{ plan.description }}</p>
                <p class="text-2xl font-bold mt-4"
                  :class="subscription && subscription.planId === plan.planId ? 'text-primary' : 'text-white'">${{
                  plan.price /100}}<span class="text-slate-200 text-sm ml-1">/{{ plan.billingCycle }}</span></p>

                <div class="mt-8 flex flex-col gap-4">
                  <div v-for="(feature, i) in plan.features" :key="i" class="flex items-center gap-3">
                    <img src="@/assets/images/landing-page/check.svg" alt="check" class="h-5 w-5"
                      style="filter: invert(88%) sepia(31%) saturate(1096%) hue-rotate(13deg) brightness(107%) contrast(96%);" />
                    <span class="text-slate-100">{{ feature }}</span>
                  </div>
                </div>

                <div class="mt-8 pt-6 border-t border-slate-700">
                  <button @click="selectPlan(plan)" :class="['w-full py-3 rounded-lg font-semibold',
                    subscription && subscription.planId === plan.planId
                      ? 'bg-slate-700 text-slate-300 cursor-not-allowed'
                      : 'bg-primary text-black hover:bg-lime-500']"
                    :disabled="subscription && subscription.planId === plan.planId">
                    {{ subscription && subscription.planId === plan.planId ? 'Current Plan' : 'Select Plan' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
import wallet from './components/wallet.vue';
import socials from './components/socials.vue';
import ConfigureTwoFactorAuth from '../../../decast/views/v2auth/ConfigureTwoFactorAuth.vue';
import constants from '../../../../constant';
import axios from 'axios';

export default {
  name: "MyProfile",
  data() {
    return {
      activeSection: "account",
      isLoadingSubscription: false,
      isLoadingPlans: false,
      form: {
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        bio: "",
        did: "",
        publicKey: "",
      },
      ui: {
        accountInfo: true,
        userInfo: true,
        didInfo: true,
        secPasswords: true,
        sec2fa: false,
        wallet: true,
        socials: true,
        vcs: true,
        subscription: true,
      },
      security: {
        newPassword: "",
        confirm: "",
      },
      subscription: null,
      availablePlans: [],
      isSaving: false,
      savedAt: "",
      showPreview: false,
    };
  },
  components: {
    wallet,
    ConfigureTwoFactorAuth,
    socials,
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    this.form = {
      username: userInfo.username || '',
      email: userInfo.email || '',
      firstName: userInfo.firstName,
      lastName: userInfo.lastName || '',
      bio: userInfo.bio || '',
      did: userInfo.socialId || '',
      publicKey: userInfo.publicKey || '',
    };

    console.log("Mounted MyProfile with userInfo:", userInfo);

    // Check for Stripe callback parameters
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('success') === 'true') {
      this.$vs.notify({
        title: 'Success',
        text: 'Subscription activated successfully!',
        color: 'success',
      });
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
      this.fetchSubscription();
    } else if (urlParams.get('canceled') === 'true') {
      this.$vs.notify({
        title: 'Canceled',
        text: 'Checkout was canceled',
        color: 'warning',
      });
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Fetch subscription and plans when subscription section is active or when component mounts
    this.fetchSubscription();
    this.fetchPlans();
  },
  watch: {
    activeSection(newSection) {
      if (newSection === 'subscription') {
        this.fetchSubscription();
        this.fetchPlans();
      }
    },
  },
  methods: {
    bindUpdatedUserData() {
      this.form = {
        username: this.activeUserInfo.username || '',
        email: this.activeUserInfo.email || '',
        firstName: this.activeUserInfo.firstName,
        lastName: this.activeUserInfo.lastName || '',
        bio: this.activeUserInfo.bio || '',
        did: this.activeUserInfo.socialId || '',
        publicKey: this.activeUserInfo.publicKey || '',
      };
    },
    setActiveModal(modalName) {
      this.activeModal = modalName;
    },
    closeModal() {
      this.activeModal = '';
      this.$router.replace({ hash: '' });
    },
    async copy(value) {
      try {
        await navigator.clipboard.writeText(value || "");
      } catch (e) {
        console.warn("Copy failed", e);
      }
    },
    openPreview() {
      this.showPreview = true;
    },
    async saveChanges() {
      this.isSaving = true;
      try {
        // Update localStorage
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        localStorage.setItem('userInfo', JSON.stringify({
          ...userInfo,
          username: this.form.username,
          email: this.form.email,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          bio: this.form.bio,
        }));
        await new Promise((r) => setTimeout(r, 500));
        this.savedAt = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      } finally {
        this.isSaving = false;
      }
    },
    changePassword() {
      if (!this.security.newPassword || this.security.newPassword !== this.security.confirm) return;
      // Wire to backend
      this.security.newPassword = "";
      this.security.confirm = "";
    },
    setup2FA() {
      // Open 2FA flow
    },
    connectWallet() {
      // Handle wallet connect
    },
    disconnectWallet() {
      // Handle wallet disconnect
    },
    async fetchSubscription() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const userId = userInfo.id || userInfo.userId;

      if (!userId) {
        console.warn('No user ID found');
        return;
      }

      this.isLoadingSubscription = true;
      try {
        const response = await axios.get(
          `${constants.stripeServiceUrl}/api/v1/subscriptions/${userId}`
        );

        if (response.data.success && response.data.data) {
          const sub = response.data.data;
          const plan = sub.plan || {};

          // Format subscription data for display
          this.subscription = {
            planName: plan.name || 'Unknown Plan',
            status: sub.status || 'Active',
            startDate: sub.currentPeriodStart
              ? new Date(sub.currentPeriodStart).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
              : 'N/A',
            nextBillingDate: sub.currentPeriodEnd
              ? new Date(sub.currentPeriodEnd).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
              : 'N/A',
            price: plan.price || 0,
            billingCycle: plan.interval === 'month' ? 'month' : plan.interval === 'year' ? 'year' : 'month',
            planId: plan.planId || '',
            features: plan.features || [] // Keep as array for consistent display
          };
        } else {
          this.subscription = null;
        }
      } catch (error) {
        console.error('Error fetching subscription:', error);
        this.subscription = null;
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load subscription information',
          color: 'danger',
        });
      } finally {
        this.isLoadingSubscription = false;
      }
    },
    async fetchPlans() {
      this.isLoadingPlans = true;
      try {
        const response = await axios.get(
          `${constants.stripeServiceUrl}/api/v1/plans?isActive=true`
        );

        if (response.data.success && response.data.data) {
          this.availablePlans = response.data.data.map(plan => ({
            planId: plan.planId,
            name: plan.name,
            description: plan.description,
            price: plan.price,
            billingCycle: plan.interval === 'month' ? 'month' : plan.interval === 'year' ? 'year' : 'month',
            features: plan.features || [],
            interval: plan.interval,
            intervalCount: plan.intervalCount,
          }));
        }
      } catch (error) {
        console.error('Error fetching plans:', error);
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load available plans',
          color: 'danger',
        });
      } finally {
        this.isLoadingPlans = false;
      }
    },
    async selectPlan(plan) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const userId = userInfo.id || userInfo.userId;

      if (!userId) {
        this.$vs.notify({
          title: 'Error',
          text: 'User ID not found. Please log in again.',
          color: 'danger',
        });
        return;
      }

      // Check if plan is already selected
      if (this.subscription && this.subscription.planId === plan.planId) {
        return;
      }

      try {
        const successUrl = `${constants.clientDomain}/dashboard/profile?success=true`;
        const cancelUrl = `${constants.clientDomain}/dashboard/profile?canceled=true`;

        const response = await axios.post(
          `${constants.stripeServiceUrl}/api/v1/subscriptions/checkout`,
          {
            userId: userId.toString(),
            planId: plan.planId,
            successUrl,
            cancelUrl,
          }
        );

        if (response.data.success && response.data.data?.url) {
          // Redirect to Stripe checkout
          window.location.href = response.data.data.url;
        } else {
          throw new Error('Failed to create checkout session');
        }
      } catch (error) {
        console.error('Error creating checkout session:', error);
        this.$vs.notify({
          title: 'Error',
          text: error.response?.data?.error || 'Failed to start checkout process',
          color: 'danger',
        });
      }
    },
    async openCustomerPortal() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const userId = userInfo.id || userInfo.userId;

      if (!userId) {
        this.$vs.notify({
          title: 'Error',
          text: 'User ID not found. Please log in again.',
          color: 'danger',
        });
        return;
      }

      if (!this.subscription) {
        this.$vs.notify({
          title: 'Error',
          text: 'No active subscription found',
          color: 'danger',
        });
        return;
      }

      try {
        const returnUrl = `${constants.clientDomain}/dashboard/profile`;

        const response = await axios.post(
          `${constants.stripeServiceUrl}/api/v1/subscriptions/portal`,
          {
            userId: userId.toString(),
            returnUrl,
          }
        );

        if (response.data.success && response.data.data?.url) {
          window.location.href = response.data.data.url;
        } else {
          throw new Error('Failed to create portal session');
        }
      } catch (error) {
        console.error('Error creating portal session:', error);
        this.$vs.notify({
          title: 'Error',
          text: error.response?.data?.error || 'Failed to open customer portal',
          color: 'danger',
        });
      }
    },
  },
};
</script>

<style scoped>
/* Collapse transition */
.collapse-enter-active,
.collapse-leave-active {
  transition: opacity 0.2s ease, max-height 0.3s ease;
  max-height: 2000px;
  /* Large enough to contain all content */
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

/* Remove default button styles */
button {
  padding: 0;
  cursor: pointer;
  background: none;
  border: 1px solid gray;
  outline: none;
}

/* Ensure inputs and textareas have no border or outline */
input,
textarea {
  border: none;
  outline: none;
}

/* Container for inputs */
input,
textarea {
  width: 100%;
}

.input_cont_ {
  border: 1px solid gray;
}

.indicator_2fa {
  border: 1px solid #d7df23
    /* Dark background for 2FA container */
}
</style>